import { render } from "./ConsentValidation.vue?vue&type=template&id=551a03e9"
import script from "./ConsentValidation.vue?vue&type=script&lang=js"
export * from "./ConsentValidation.vue?vue&type=script&lang=js"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ConsentValidation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "551a03e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('551a03e9', __exports__)) {
    api.reload('551a03e9', __exports__)
  }
  
  module.hot.accept("./ConsentValidation.vue?vue&type=template&id=551a03e9", () => {
    api.rerender('551a03e9', render)
  })

}


export default __exports__